export default {"AppSideBar":"AppSideBar-module__AppSideBar__WJYzo","MinimizeButton":"AppSideBar-module__MinimizeButton__joz3m"};